import React from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const JF = "'Josefin Sans', sans-serif";
const PJ = "'Plus Jakarta Sans', sans-serif";

const activeProjectsList = [
  {
    id: "ba1b9ccd-9897-45a0-8d5f-38cbf5e5f358",
    name: "In Phu Sec Lab",
    url: "https://youtube.com/@inphuseclab",
    description: "Focused YouTube videos on various cybersecurity topics.",
    external: true,
  },
  {
    id: "61626818-148b-4f3a-9662-c0585a155ed2",
    name: "In Phu Sec Notes",
    url: "https://inphusecnotes.hhphu.com/",
    description: "A curated reference of cybersecurity and programming cheatsheets.",
    external: true,
  },
];

export default function ActiveProjects() {
  const labelColor   = useColorModeValue("#888888", "#aaaaaa");
  const dividerColor = useColorModeValue("#e8e8e8", "#2a2a2a");
  const titleColor   = useColorModeValue("#0c0c0c", "#f0f0f0");
  const titleHover   = useColorModeValue("#888888", "#777777");
  const descColor    = useColorModeValue("#555555", "#999999");
  const ctaColor     = useColorModeValue("#aaaaaa", "#888888");

  return (
    <Box as="section" pt={14} pb={12}>

      {/* Section label */}
      <Text
        fontFamily={JF}
        fontSize="13px"
        fontWeight="700"
        letterSpacing="0.2em"
        textTransform="uppercase"
        color={labelColor}
        mb={5}
      >
        Currently Working On
      </Text>

      {activeProjectsList.map((project, idx) => (
        <React.Fragment key={project.id}>
          <Link
            to={project.url}
            target={project.external ? "_blank" : undefined}
            rel={project.external ? "noreferrer" : undefined}
          >
            <Box
              py={3}
              sx={{
                "&:hover .proj-title": { color: titleHover },
                "&:hover .proj-cta":   { letterSpacing: "0.22em" },
              }}
            >
              {/* Project name */}
              <Text
                className="proj-title"
                fontFamily={PJ}
                fontSize="17px"
                fontWeight="600"
                color={titleColor}
                lineHeight={1.4}
                mb={2}
                transition="color 0.2s ease"
                display="inline-flex"
                alignItems="center"
                gap="5px"
              >
                {project.name}
                <i
                  className="ri-arrow-right-up-line"
                  style={{ fontSize: "12px", opacity: 0.5 }}
                />
              </Text>

              {/* Description */}
              <Text
                fontFamily={PJ}
                fontSize="16px"
                color={descColor}
                lineHeight="1.75"
                mb={3}
              >
                {project.description}
              </Text>

              {/* CTA */}
              <Text
                className="proj-cta"
                fontFamily={JF}
                fontSize="12px"
                fontWeight="600"
                letterSpacing="0.2em"
                textTransform="uppercase"
                color={ctaColor}
                transition="letter-spacing 0.2s ease"
              >
                View →
              </Text>
            </Box>
          </Link>

          {/* Divider between items */}
          {idx < activeProjectsList.length - 1 && (
            <Box h="1px" bg={dividerColor} />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
}
